export default {
  LOCAL_STORAGE_KEYS: {
    coinbaseStaking: 'coinbase-staking-store'
  },
  VERSION: {
    coinbaseStaking: '0.0.2'
  }
};
